import { Trans } from '@lingui/react';

import AdminToolbar, {
  AdminButton,
} from '@rover/react-lib/src/components/AdminToolbar/AdminToolbar';
import useLocationContext from '@rover/react-lib/src/context/useLocationContext';

const getOpkFromPathname = (path: string): string => {
  const matcher = /\/members\/profile\/(?<opk>[\w-]+)/;
  return path.match(matcher)?.groups?.opk || '';
};

const OwnerProfileAdminToolbar = (): JSX.Element => {
  const location = useLocationContext();
  const { pathname } = location;

  const personOpk = getOpkFromPathname(pathname);
  const firstName = 'user';

  const personUrl = `/admin/people/person/?opk=${personOpk}`;
  const impersonationUrl = `/admin/people/person/become_person/${personOpk}/?next=${pathname}`;

  return (
    <AdminToolbar>
      <AdminButton href={personUrl}>
        <Trans id="View in People" />
      </AdminButton>
      <AdminButton href={impersonationUrl}>
        <Trans id={`Login as ${firstName}`} />
      </AdminButton>
    </AdminToolbar>
  );
};

export default OwnerProfileAdminToolbar;
